import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Construction, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SafeModeGuardProps {
  feature: string;
  children: React.ReactNode;
}

export function SafeModeGuard({ feature, children }: SafeModeGuardProps) {
  const navigate = useNavigate();
  const safeMode = import.meta.env.VITE_SAFE_MODE === 'true';

  if (!safeMode) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <Construction className="w-12 h-12 text-orange-500 mx-auto mb-4" />
          <CardTitle>Temporarily Unavailable</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground">
            The {feature} feature is temporarily disabled while we fix some issues.
          </p>
          <p className="text-sm text-muted-foreground">
            Safe Mode is currently active to ensure a stable experience.
          </p>
          <Button onClick={() => navigate('/')} className="w-full">
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}